import { useEffect } from 'react';
import { setUserId } from '@/utils/analytics';
import { useSession } from '@zopauk/nextjs-auth';

export const Amplitude = () => {
  const { data: session, status } = useSession();

  // Define the member id
  useEffect(() => {
    if (status === 'authenticated' && session.user?.memberId) {
      setUserId(session.user.memberId);
    }
  }, [session, status]);

  return null;
};
